<template>
  <div>
    <b-container>
      <b-row align-h="between" style="margin-left: 0; margin-right: 0;">
        <h3>Entschuldigungen:</h3>
        <div>
          <b-button variant="outline-primary" to="/Entschuldigungen/drucken" style="margin-right: 10px;">Druck Ansicht
          </b-button>
          <b-button variant="outline-danger" v-b-modal.modal-prevent-closing>Löschen</b-button>
        </div>
      </b-row>
      <hr class="mt-4 mb-4">
      <div class="overflow-auto">
        <b-pagination-nav
            :link-gen="linkGen"
            :number-of-pages="pages"
            align="fill"
            use-router
        />
      </div>
      <b-list-group
          class="list"
          flush
      >
        <b-list-group-item
            v-for="excuse in excuses"
            :key="excuse.id"
            :to="{ path: `Entschuldigung/${excuse.id}`}"
            class="flex-column align-items-start"
        >
          <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1 text-primary">
              {{ excuse.child_name }}
            </h5>
            <small class="text-muted createdDate" v-if="excuse.end !== null">{{ date(excuse.start) }} -
              {{ date(excuse.end) }}</small>
            <small class="text-muted createdDate" v-else>{{ date(excuse.start) }}</small>
          </div>

          <p class="mb-1">
            {{ excuse.description }}
          </p>
        </b-list-group-item>
      </b-list-group>
    </b-container>


    <b-modal
        id="modal-prevent-closing"
        ref="modal"
        title="Einträge löschen"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
        cancel-title="Abbrechen"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
            :state="nameState"
            label="Name de Kindes:"
            label-for="name-input"
            invalid-feedback="Bitte geben Sie einen Namen ein."
        >
          <b-form-input
              id="name-input"
              v-model="name"
              :state="nameState"
              required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "ExcuseList",
  data() {
    return {
      name: '',
      nameState: null,
    }
  },
  computed: {
    ...mapGetters([
      'getStoredExcusesByPage',
      'getExcusePages'
    ]),
    excuses() {
      return this.getStoredExcusesByPage(parseInt(this.$route.query.page))
    },
    pages() {
      return this.getExcusePages
    },
  },
  watch: {
    '$route.query.page'() {
      this.getExcuses(this.$route.query.page)
    }
  },
  mounted() {
    this.getExcuses(this.$route.query.page)
  },
  methods: {
    ...mapActions([
      'getExcuses',
      'deleteExcuseByName'
    ]),
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      // Push the name to submitted names
      this.deleteExcuseByName(this.name)
      // Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    date(date) {
      const d = new Date(date)
      return ('0' + d.getDate()).slice(-2) + '.' + ('0' + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear()
    }
  }
}
</script>

<style scoped>
.createdDate {
  flex: inherit !important;
}

.list {
  border: 1px lightgrey solid;
}
</style>
